import React from 'react';
import { useIntl } from 'react-intl';

import { createStyles, withStyles } from '@material-ui/core';
import classnames from 'classnames';

import EmptyState from '../EmptyState';
import ErrorBoundary from '../ErrorBoundary';
import { LumaTheme } from '../styles/getTheme';

import messages from './messages';

const styles = ({ palette: { background } }: LumaTheme) =>
  createStyles({
    root: {
      backgroundColor: background.default,
    },
  });

interface ErrorBoundaryAppProps {
  classes: any;
  className?: string;
}

const ErrorBoundaryApp: React.FC<ErrorBoundaryAppProps> = ({ classes, className, ...rest }) => {
  const { formatMessage } = useIntl();

  return (
    <ErrorBoundary
      fallback={
        <EmptyState className={classnames(classes.root, className)} icon="🐻" title={formatMessage(messages.title)}>
          {formatMessage(messages.message)}
        </EmptyState>
      }
      {...rest}
    />
  );
};

export default withStyles(styles)(ErrorBoundaryApp);
